import React from 'react';

const ContentUseCase = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <div className="mt-8 text-gray-700">
      {content}
    </div>
  );
};

export default ContentUseCase;